// CommonJS de propósito: usado pelo vue.config.js (Node) e pelo bundle. Regras: docs/multiplo-web/plugins/envParceiro.md
const chavesEnvParceiro = ['VUE_APP_NOME', 'VUE_APP_AMBIENTE', 'VUE_APP_CUSTOMIZACAO']

function parseEnvParceiro (conteudo) {
  const env = {}
  conteudo.split(/\r?\n|\r/).forEach(line => {
    const [key, val] = line.split(/\s*=\s*(.+)/)
    if (chavesEnvParceiro.includes(key && key.trim())) { env[key.trim()] = val.trim() }
  })
  return env
}

function caminhoJsonParceiro (caminhoEnv) {
  return `parceiros/${caminhoEnv.split(/[\\/]/).pop().replace(/^\.env\./, '')}.json`
}

function ambienteValido (ambiente) {
  return typeof ambiente === 'string' && /^[a-z0-9_]+$/i.test(ambiente)
}

module.exports = { chavesEnvParceiro, parseEnvParceiro, caminhoJsonParceiro, ambienteValido }
